import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { CreatePollRequest, UpdatePollRequest, ViewPollResultsRequest } from './poll.types';

import { requestCreatePoll, requestUpdatePoll, requestViewPollResults } from './poll.actions';

export const usePollApi = () => {
  const dispatch = useDispatch();

  const createPoll = useCallback(
    (requestData: CreatePollRequest, onSuccess?: () => void) => {
      dispatch(requestCreatePoll({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const updatePoll = useCallback(
    (requestData: UpdatePollRequest, onSuccess?: () => void) => {
      dispatch(requestUpdatePoll({ requestData, onSuccess }));
    },
    [dispatch]
  );

  const viewPollResults = useCallback(
    (requestData: ViewPollResultsRequest, onSuccess?: () => void) => {
      dispatch(requestViewPollResults({ requestData, onSuccess }));
    },
    [dispatch]
  );

  return { createPoll, updatePoll, viewPollResults };
};
